<template>
  <div id="app">
    <Header />
    <div class="main-container">
      <router-view />
    </div>
    <Footer />
    <FloatingToolbar />
  </div>
</template>

<script>
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import FloatingToolbar from '@/components/common/FloatingToolbar.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    FloatingToolbar
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

.main-container {
  min-height: calc(100vh - 450px);
}

/* Global styles */
.section-title {
  text-align: center;
  margin-bottom: 40px;
  
  h2 {
    font-size: 28px;
    color: #333;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;
    
    &:after {
      content: "";
      display: block;
      width: 40px;
      height: 3px;
      background-color: #1ebec8;
      margin: 10px auto 0;
    }
  }
  
  p {
    font-size: 16px;
    color: #666;
  }
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  
  @media (max-width: 1200px) {
    width: 100%;
  }
}

.section {
  padding: 60px 0;
}

.page-header {
  background-color: #f5f5f5;
  padding: 40px 0;
  margin-bottom: 40px;
  
  h1 {
    font-size: 32px;
    color: #333;
    margin-bottom: 10px;
  }
  
  .breadcrumb {
    color: #666;
  }
}
</style> 